var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-app-wrapper"},[_c('vue-pdf-app',{attrs:{"pdf":_vm.path,"theme":"light","page-scale":"page-fit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }